import './Nav.scss'
import { GoabAppHeaderMenu } from "@abgov/react-components";
import { useAuth } from 'react-oidc-context';
import { parseToken } from '../../common/utils/tokenUtil';

export const Nav = () => {
  const auth = useAuth();
  const logout = () => {
    if (!auth.isLoading && auth.isAuthenticated) {
      auth.signoutRedirect({ id_token_hint: auth.user?.id_token }).then();
    }
  };
  return (
    <div style={{display: 'inline-block'}}>
      {auth.isAuthenticated &&
        <>
          <GoabAppHeaderMenu heading={parseToken(auth.user?.id_token as string)?.email} leadingIcon="person-circle">
            <a href='/my-account'>User profile</a>
          {// eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a role="button" tabIndex={0} onClick={logout} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); logout(); } }}>Log out</a>
          }
          {// eslint-disable-next-line jsx-a11y/anchor-is-valid
            <a role="button" tabIndex={0} onClick={() => { auth.signinSilent().then().catch() }} onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); auth.signinSilent().then().catch(); } }}>Get new token</a>
          }
          </GoabAppHeaderMenu>
        </>
      }
    </div>
  )
};

